import styled from 'styled-components'
import { Form } from '@/components/__Inputs'
import { Heading, Text } from '@awazevr/design-system.components.text'
import { Label } from '@awazevr/design-system.components.input'

export const BookingSection = styled.div`
  font-size: 0.8rem;
`

export const AlertWarning = styled.div`
  margin-bottom: 1rem;
`

export const Section = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin: 1rem 0;
  
 ${({ theme }) => theme.mediaQueries.tabletDownDS} {
    flex-direction: column;
    align-items: flex-start;
  }
`

export const SubSection = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;

  ${({ theme }) => theme.mediaQueries.tabletDownDS} {
    margin-bottom: 1.5rem;

    &:last-child {
      margin-bottom: 0;
    }
  }

  ${({ theme }) => theme.mediaQueries.laptopUpDS} {
    max-width: 16rem;
  }
`
export const SubSectionFullWidth = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  ${({ theme }) => theme.mediaQueries.tabletDownDS} {
    margin-bottom: 1.5rem;
    &:last-child {
      margin-bottom: 0;
    }
  }
`

export const SectionLabelUnit = styled.div`
  margin-bottom: 2rem;
  font-weight: 600;
`
export const SectionTitle = styled.div`
${({ theme }) => theme.fonts.Text300}
margin-bottom: 0.5rem;
font-weight: 500;
`
export const SectionTitleTotal = styled.div`
  font-weight: 700;
  font-size: 1rem;
`

export const SectionLabel = styled.div`
  font-weight: 600;
  border: 1px solid red;
`

export const SectionData = styled(Text)`
  font-size: 1rem;
  margin-top: 0.5rem;
  
  input {
    margin-bottom: 0.6rem;
  }
`

export const SectionDropdown = styled.div`
  font-size: 1rem;
`
export const QuoteSection = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: nowrap;
  align-items: center;
  margin: 0.5rem 0 1rem 0;

  & > * {
    flex: 1;
  }
`
export const SpinnerTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  
  & > *:not(:last-child) {
    margin-bottom: 1.5rem;
  }
`

export const Quote = styled.div`
  height: auto; 
  width: auto; 
  background: ${({ theme }) => theme.colors.quoteBackground};
  display: flex;
  flex-direction: column; 
  margin-bottom: 1.5rem;
  padding-top: .5rem;
  padding-left: .8rem; 
  border-radius: .3rem;

  h4 {
    margin-bottom: 1rem;
    font-weight: 600;
    font-size: 1.1rem;
  }

  .priceContainer{ 
    height: 2rem; 
    width: auto;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  ${({ theme }) => theme.mediaQueries.phoneDS} {
    .priceContainer{ 
      height: 3rem; 
      justify-content: space-between;
      padding-right: 1rem;
    }
  }
`

export const ButtonWrapper = styled.div`
  display: flex;
  gap: 1.5rem;

  ${({ theme }) => theme.mediaQueries.phoneDS} {
    flex-direction: column-reverse;
    gap: 1rem;
  }
`


export const StyledHeading = styled(Heading)`
  margin-top: 1rem;
`
export const BookingForm = styled(Form)``

export const StyledHeader = styled(Heading)`
  font-size: 1.5rem;

  ${({ theme }) => theme.mediaQueries.phoneDS} {
    font-size: 1.25rem; 
  }
`
export const StyledDurationLabel = styled(Label)`
margin-bottom: 0.5rem;
`
